/**
 * 用户认证组件
 * 显示登录按钮或用户头像，处理登录/登出
 */
import React, { useState } from 'react';
import { Button, Avatar, Dropdown, Space, Typography } from 'antd';
import { UserOutlined, LoginOutlined, LogoutOutlined, CrownOutlined } from '@ant-design/icons';
import { GoogleLogin } from '@react-oauth/google';
import { useUser } from '../contexts/UserContext';
import UpgradeModal from './UpgradeModal';
import './UserAuth.css';

const { Text } = Typography;

const UserAuth = () => {
  const { user, login, logout, isTester, isNormal } = useUser();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Google 登录成功回调
  const handleGoogleSuccess = async (credentialResponse) => {
    const success = await login(credentialResponse.credential);
    if (success) {
      // 登录成功后刷新页面状态
      window.location.reload();
    }
  };

  // Google 登录失败回调
  const handleGoogleError = () => {
    console.error('Google login failed');
  };

  // 登出
  const handleLogout = () => {
    logout();
    window.location.reload();
  };

  // 用户菜单项
  const menuItems = user ? [
    {
      key: 'user-info',
      disabled: true,
      label: (
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Text strong>{user.display_name || user.email}</Text>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {user.email}
          </Text>
          {isTester() && (
            <Text type="success" style={{ fontSize: '12px' }}>
              <CrownOutlined /> 内测用户
            </Text>
          )}
          {isNormal() && (
            <Text type="secondary" style={{ fontSize: '12px' }}>
              普通用户
            </Text>
          )}
        </Space>
      ),
    },
    { type: 'divider' },
    ...(isNormal() ? [{
      key: 'upgrade',
      icon: <CrownOutlined />,
      label: '升级成为内测用户',
      onClick: () => setShowUpgradeModal(true),
    }] : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '登出',
      danger: true,
      onClick: handleLogout,
    },
  ] : [];

  return (
    <div className="user-auth">
      {user ? (
        <Dropdown menu={{ items: menuItems }} placement="topLeft">
          <Space className="user-avatar-wrapper" style={{ cursor: 'pointer' }}>
            <Avatar
              src={user.avatar_url || undefined}
              icon={!user.avatar_url ? <UserOutlined /> : undefined}
              size="default"
            />
          </Space>
        </Dropdown>
      ) : (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          render={({ onClick }) => (
            <Button
              type="primary"
              icon={<LoginOutlined />}
              onClick={onClick}
              size="small"
            >
              登录
            </Button>
          )}
        />
      )}

      {showUpgradeModal && (
        <UpgradeModal
          visible={showUpgradeModal}
          onClose={() => setShowUpgradeModal(false)}
        />
      )}
    </div>
  );
};

export default UserAuth;

